import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  tableName !: string;
  totalRequests:number=0
   env=environment
  public openDialogBoxSubject: BehaviorSubject<any> = new BehaviorSubject(0)
  constructor() { }


  refresh() {
    this.clearCache()
   
    // const uniqueTimestamp = Date.now().toString();
    // const separator = window.location.href.includes('?') ? '&' : '?';
    // window.location.href = window.location.href.split('?')[0] + separator + 't=' + uniqueTimestamp;
  }
  clearCache() {
    if ('serviceWorker' in navigator) {
      navigator?.serviceWorker?.getRegistrations().then(registrations => {
        for (const registration of registrations) {
          registration.unregister();
        }
      });
    }
    this.clearCacheAndReload();
   
  }
  clearCacheAndReload() {
    if ('caches' in window) {
      caches?.keys()?.then((names) => {
        names?.forEach(name => {
          caches?.delete(name);
        });
      });
    }
 
    window.location.hash = Date.now().toString();
    this.forceHardReload();
   
  }
   forceHardReload() {
    fetch(window.location.href, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    }).then(() => {
      location.reload();
        localStorage.setItem('version',this.env._version)
    });

        

  }
  
}
